<div>
  <div class="modal-header">
    <h4 class="modal-title" translate="services.craning.slots.modal.generate.title"></h4>

    <button class="btn-close" aria-label="Close"
      (click)="craningBookingSlotsGenerationModal.dismiss('Cross click')">
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="craningBookingSlotsGenerationForm">

      <div class="row">

        <!-- date period -->
        <div class="col-12">
          <app-date-period-picker [required]="true"
            [fromMinDate]="minDate"
            [toMinDate]="minDate"
          [periodControl]="datePeriod"></app-date-period-picker>
        </div>

        <!-- time period -->
        <div class="row" formGroupName="timePeriod">
          <div class="col-12 col-sm-6">
            <label class="form-label" for="startTime">{{ 'services.craning.slots.form.generate.startTime' | translate }}*</label>

            <ngb-timepicker id="startTime" formControlName="from"></ngb-timepicker>
            <app-form-error [control]="startTime"></app-form-error>
          </div>

          <div class="col-12 col-sm-6">
            <label class="form-label" for="lastStartTimeOfTheDay">{{ 'services.craning.slots.form.generate.lastStartTimeOfTheDay' | translate }}*</label>

            <ngb-timepicker id="lastStartTimeOfTheDay" formControlName="to"></ngb-timepicker>
            <app-form-error [control]="lastStartTimeOfTheDay"></app-form-error>
            <app-form-error [control]="timePeriod"></app-form-error>
          </div>
        </div>

        <!-- slotDuration -->
        <div class="col-12 col-sm-6">
          <label class="form-label" for="slotDuration">{{ 'services.craning.slots.form.generate.slotDuration' | translate }}*</label>

          <ngb-timepicker id="slotDuration" formControlName="slotDuration"></ngb-timepicker>
          <app-form-error [control]="slotDuration"></app-form-error>
        </div>

        <!-- state -->
        <div class="col-12 col-sm-6">
          <label class="form-label">{{ 'services.craning.slots.form.generate.state' | translate}}*</label>

          <div>
            <div class="btn-group" role="group">
              <input class="btn-check" type="radio"
                [formControl]="state"
                [value]="CraningBookingSlotState.Free">
                <label class="btn btn-toggle btn-toggle-left h-auto"
                  [ngClass]="{ active: state.value === CraningBookingSlotState.Free }"
                  (click)="state.setValue(CraningBookingSlotState.Free);"
                  (keyup)="state.setValue(CraningBookingSlotState.Free);">
                  {{ 'services.craning.slots.stateEnum.' + CraningBookingSlotState.Free | translate }}
                </label>

                <input class="btn-check" type="radio"
                  [formControl]="state"
                  [value]="CraningBookingSlotState.Blocked">
                  <label class="btn btn-toggle btn-toggle-right h-auto"
                    [ngClass]="{ active: state.value === CraningBookingSlotState.Blocked }"
                    (click)="state.setValue(CraningBookingSlotState.Blocked);"
                    (keyup)="state.setValue(CraningBookingSlotState.Blocked);">
                    {{ 'services.craning.slots.stateEnum.' + CraningBookingSlotState.Blocked | translate }}
                  </label>
                </div>
              </div>

            </div>

            <!-- days -->
            <div class="col-12 col-sm-6">
              <label class="form-label" translate="services.craning.slots.form.generate.days"></label>

              @for (day of daysOfWeek; track day; let i = $index) {
                <div class="form-check form-switch">
                  <input type="checkbox" class="form-check-input" id="day-{{ day }}"
                    formArrayName="days"
                    [formControl]="days.get('' + i)"
                    [value]="days.value[i]">
                    <label class="form-check-label" for="day-{{ day }}">{{ 'common.day.' + day | translate }}</label>
                  </div>
                }
              </div>

            </div>


            @if (lastCraningBookingSlotsGenerationResult?.conflictingBookingSlots.length > 0) {
              <div class="row conflict-list mt-4">
                <div class="col-12">
                  <h4 translate="services.craning.slots.form.generate.conflicts.title"></h4>
                  <ul>
                    @for (conflict of lastCraningBookingSlotsGenerationResult.conflictingBookingSlots; track conflict) {
                      <li>
                        {{ 'services.craning.slots.form.generate.conflicts.message' | translate:{
                        date: conflict.date | date,
                        startTime: DateUtils.formatTime(conflict.startTime),
                        endTime: DateUtils.formatTime(conflict.endTime)
                      }
                      }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          }

        </form>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-secondary"
          (click)="craningBookingSlotsGenerationModal.close()"
          translate="common.close">
        </button>

        <button class="btn btn-primary" type="submit"
          [disabled]="craningBookingSlotsGenerationForm.invalid"
          (click)="generateCraningBookingSlots()"
          translate="common.generate">
        </button>
      </div>
    </div>

